export default __webpack_public_path__ + "static/media/may-2017.59381e3e.csv";